export default {
    apiKey: "AIzaSyDwAY_1Rnf4nxFnCLZu36ltYlw8WV4x9dY",
    authDomain: "lyfe-planner.firebaseapp.com",
    databaseURL: "https://lyfe-planner.firebaseio.com",
    projectId: "lyfe-planner",
    storageBucket: "lyfe-planner.appspot.com",
    messagingSenderId: "182376036177",
    appId: "1:182376036177:web:c3f7169829b72da1"
  }